module.exports = __webpack_public_path__ + "img/empty@2x.1d4f6543.png";